import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, FunctionComponent, useEffect, useState } from 'react';

const numberValueToString = (val: number | null) => val?.toString() || '';

export type NumberInputProps = Omit<
    TextFieldProps,
    'onChange' | 'value' | 'defaultValue' | 'type'
> & {
    value?: number | null;
    defaultValue?: number | null;
    onChange?: (nextValue: number | null) => void;
};

export const NumberInput: FunctionComponent<NumberInputProps> = ({
    value,
    defaultValue,
    onChange,
    ...rest
}) => {
    const [internalValue, setInternalValue] = useState(
        numberValueToString((defaultValue || value) ?? null)
    );

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        let numberValue = null;
        if (value) {
            if (!isNaN(parseInt(value))) {
                numberValue = parseInt(value);
            }
        }

        setInternalValue(numberValue?.toString() || '');
        onChange?.(numberValue);
    };

    useEffect(() => {
        if (isNaN(value as number)) {
            setInternalValue(numberValueToString(value));
        }
    }, [value]);

    return (
        <TextField
            {...(rest as TextFieldProps)}
            value={internalValue}
            onChange={onInputChange}
            autoComplete='off'
        />
    );
};
